// Auto-generated — do not edit
import { i18nBundle } from '@amzn/amp-i18n'
import type {
    ExplicitLanguageFilterGetString,
    ExplicitLanguageFilterGetStringAsync,
} from './types.generated'

const explicitLanguageFilterLocales = ['en-US'] as const
const explicitLanguageFilterBundle = i18nBundle(
    'explicitLanguageFilter/explicitLanguageFilter',
    explicitLanguageFilterLocales
)

export const getString: ExplicitLanguageFilterGetString = explicitLanguageFilterBundle.getString
export const getStringAsync: ExplicitLanguageFilterGetStringAsync =
    explicitLanguageFilterBundle.getStringAsync
